export interface ReportPager { total: number; page: number; page_size: number }
export interface ReportPage<T> { data: T[]; pager: ReportPager }
export interface FinancePurchase {
    purchase_key: string; course_key: string; course_name: string; customer_name: string; customer_email: string;
    status: string; paddle_status: string | null; currency_code: string; environment: string;
    payable_minor: string; total_minor: string | null; created_at: string; completed_at: string | null;
    invoice_number: string | null; last_error_code: string | null;
}
export interface FinanceAdjustment {
    reference: string; action: string; status: string; reason: string | null; total_minor: string;
    purchase_key?: string; course_name?: string; updated_at: string; currency_code?: string;
}
export interface FinanceCourse {
    key: string; name: string; orders: number; payments_minor: string; refunds_minor: string;
    discounts_minor: string; after_refunds_minor: string; average_minor: string | null;
}
export interface FinanceAttention {
    item_key: string; kind: string; purchase_key: string | null; description: string; status: string;
    reference: string; recorded_at: string; error_code: string | null;
}
export interface AdminFinanceDto {
    filters: { days: number; environment: string; currency: string; timezone: string };
    overview: { orders: number; payments_minor: string; tax_minor: string; refunds_minor: string; after_refunds_minor: string;
        average_minor: string | null; missing_totals: number; discounts_minor: string; attention_items: number };
    days: { date: string; payments_minor: string; refunds_minor: string }[];
    course_options: { key: string; name: string }[]; currencies: string[];
    courses: ReportPage<FinanceCourse>; transactions: ReportPage<FinancePurchase>; adjustments: ReportPage<FinanceAdjustment>;
    promotions: ReportPage<{ course_name: string; code: string; orders: number; discount_minor: string; payments_minor: string }>;
    attention: ReportPage<FinanceAttention>;
}
export interface FinancePurchaseDetails extends FinancePurchase {
    paddle_transaction_id: string | null; paddle_customer_id: string | null; invoice_id: string | null;
    quoted_minor: string; discount_minor: string; subtotal_minor: string | null; tax_minor: string | null;
    promo_code: string | null; fulfilled_at: string | null; adjustments: FinanceAdjustment[];
}

/** Format integer minor units exactly, including negative amounts and currencies with zero decimals. */
export function formatReportMoney(value: string | null, currency: string): string {
    if (value === null) return '—';
    const formatter = new Intl.NumberFormat(undefined, { style: 'currency', currency });
    const decimals = formatter.resolvedOptions().maximumFractionDigits;
    const amount = BigInt(value), negative = amount < BigInt(0), absolute = negative ? -amount : amount;
    const factor = BigInt('1' + '0'.repeat(decimals));
    const major = absolute / factor;
    const fraction = (absolute % factor).toString().padStart(decimals, '0');
    const signed = negative ? (major === BigInt(0) ? -0 : -major) : major;
    return formatter.formatToParts(signed).map(part => part.type === 'fraction' ? fraction : part.value).join('');
}
